import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Raleway%22,%22arguments%22:[{%22weight%22:%22800%22,%22subsets%22:[%22latin%22],%22display%22:%22swap%22}],%22variableName%22:%22raleway%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Raleway', 'Raleway Fallback'",
        fontWeight: 800,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
